import { shape, string } from 'prop-types'

/**
 * @typedef {Object} ObjectCoolingDevice
 * @property {string} objectId the ID of the object
 * @property {string} coolingDeviceId the ID of the cooling device
 * @property {string} objectCoolingDeviceId the ID of the object to cooling device mapping
 */

export const objectCoolingDevicePropType = shape({
    coolingDeviceId: string.isRequired,
    objectCoolingDeviceId: string.isRequired,
    objectId: string.isRequired
})
